import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PartnerService } from '../../../services/partner.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-add-edit-franchise',
  templateUrl: './add-edit-franchise.component.html',
  styleUrls: ['./add-edit-franchise.component.scss'],
  providers: [MessageService]
})
export class AddEditFranchiseComponent implements OnInit {
  @Input() franchiseId;
  @Input() messageService;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  public franchiseForm: FormGroup;
  public busy = false;
  public loadingForm = false;
  public franchiseDetails : any;

  public modalTitle : any;
  public modalSaveBtnText : any;

  constructor(private fb: FormBuilder, 
    public modal: NgbActiveModal,
    private partnerService: PartnerService) { 
  }

  ngOnInit() {
    this.loadingForm = true;
    if(this.franchiseId != null)
    {
      this.modalTitle = "Edit";
      this.modalSaveBtnText = "Update";
      this.getFranchiseDetails();
    }
    else{
      this.modalTitle = "Create";
      this.modalSaveBtnText = "Add";
      this.setupValidation();
    }
  }

  setupValidation() {
    this.franchiseForm = this.fb.group({
      'name': new FormControl(this.franchiseDetails == null ? '' : this.franchiseDetails.name, Validators.required),
      'passwordResetTemplateID': new FormControl(this.franchiseDetails == null ? '' : this.franchiseDetails.passwordResetTemplateID, Validators.nullValidator),
      'customPortalCSS': new FormControl(this.franchiseDetails == null ? '' : this.franchiseDetails.customPortalCSS, Validators.nullValidator),
      'customWidgetCSS': new FormControl(this.franchiseDetails == null ? '' : this.franchiseDetails.customWidgetCSS, Validators.nullValidator),
      'fromNumber': new FormControl(this.franchiseDetails == null ? '' : this.franchiseDetails.fromNumber, Validators.nullValidator),
      'generateDataFeedReport': new FormControl(this.franchiseDetails == null ? false : this.franchiseDetails.generateDataFeedReport, Validators.nullValidator)
    });
    this.loadingForm = false;
  }

  getFranchiseDetails(){
    this.partnerService.getFranchiseDetails(this.franchiseId).subscribe(partnerParent => {
      console.log(partnerParent);
      this.franchiseDetails = partnerParent;
      this.setupValidation();
    });
  }

  saveFranchise(formData) {
    this.busy = true;
    let franchiseData = formData;    
    console.log(formData);

    if(this.franchiseId != null)
    {
      franchiseData.Id = this.franchiseDetails.id;

      //Update
      this.partnerService.postUpdateFranchise(franchiseData).subscribe(res => {
        console.log('Updated franchise');
        this.messageService.add({detail:"Franchise data has been saved"});
        this.passEntry.emit(franchiseData);
        this.busy = false; 
        this.modal.close();
       }, error=>{
         this.busy = false;  
       });
    }
    else{
      //New
      this.partnerService.postCreateNewFranchise(franchiseData).subscribe(res => {
        console.log('Added franchise');
        console.log(res);
        this.messageService.add({detail:"Franchise data has been saved"});
        franchiseData.Id = res.id;
        this.passEntry.emit(franchiseData);
        this.modal.close();
       }, error=>{
         this.busy = false;  
       });
    }        
  }  
}
